/**
 * Debounced city search hook. Empty query → quick-picks for the scope; typing →
 * prefix search. `country` is the language-gated scope ('RS'|'HR'|'BA'|'all').
 * Replaces shipping the whole ~98k catalogue to the client.
 */
import { useEffect, useState } from 'react';
import type { CityDto } from '@waylo/shared';
import { quickPickCities, searchCitiesApi } from './api';

export function useCityResults(
  query: string,
  country: string,
  enabled = true,
): { results: CityDto[]; loading: boolean } {
  const [results, setResults] = useState<CityDto[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    const term = query.trim();
    setLoading(true);
    const delay = term === '' ? 0 : 250;
    const t = setTimeout(() => {
      const p = term === '' ? quickPickCities(country) : searchCitiesApi(term, country);
      p.then((res) => {
        if (!cancelled) setResults(res.items);
      })
        .catch(() => {
          if (!cancelled) setResults([]);
        })
        .finally(() => {
          if (!cancelled) setLoading(false);
        });
    }, delay);
    return () => {
      cancelled = true;
      clearTimeout(t);
    };
  }, [query, country, enabled]);

  return { results, loading };
}
